const state = {
  active:'',
  activeDynamicList:[]
}
const getters = {
  
}
const mutations = {
  Update_Active(state,activeName){
    state.active = activeName
  },
  Update_Active_Dynamic_List(state,activeDynamicList){
    state.activeDynamicList = activeDynamicList
  }
}
const actions = {
 
}
export default {
  state, 
  getters,
  mutations,
  actions
}
